export const SLIDE_CONTENT_WIDTH = 240;
export const SLIDE_CONTENT_HEIGHT = 423;

export const SLIDE_TRANSITION_DESKTOP_MS = 450;

export const BREAKPOINT_SM_1_VALUE = 800;
export const BREAKPOINT_SM_2_VALUE = 950;
